import React, { forwardRef, useImperativeHandle } from "react";
import SearchList from "../../utils/Images/SearchList";
import { InputField } from "ui-components";
import "./SearchSuggestion.scss";
import { useTranslation } from "react-i18next";
import CircleCrossIcon from "../../utils/Images/CircleCrossIcon";
import { getSessionStorageItem } from "../../utils/SessionStorageMethod/getSessionStorageItem";

interface SearchSuggestionProps {
  suggestions?: any;
  searchTerm: string;
  onChange: any;
  onAddSuggestionClick: any;
  onKeywordSearchCrossClick: any;
  addedKeywordsList: any;
  loadingSuggestions?: boolean;
}

const SearchSuggestion = forwardRef((props: SearchSuggestionProps, ref) => {
  const {
    suggestions,
    searchTerm,
    onChange,
    onAddSuggestionClick,
    onKeywordSearchCrossClick,
    addedKeywordsList,
    loadingSuggestions,
  } = props;
  const { t } = useTranslation();
  const handleAddSuggestion = (item: any) => {
    const isSkillPresent = addedKeywordsList?.some((keyword: any) => {
      keyword.skillId === item.skillId &&
        keyword.keywords.toLowerCase() === item.keywords.toLowerCase() &&
        item?.level?.includes(keyword?.level);
    });
    if (isSkillPresent) return;
    // Retrieve and filter the API keywords based on the current item's keywords
    const apiKeywords = getSessionStorageItem("unfilterdSkillKeywords");
    const filteredKeywords = apiKeywords.filter((apiKey: any) =>
      apiKey?.keywords
        ?.split(",")
        .some((keyword: any) =>
          keyword?.toLowerCase()?.includes(item?.keywords?.toLowerCase()),
        ),
    );
    const levels = Array.from(
      new Set(filteredKeywords.map((apiKey: any) => apiKey.level)),
    );
    const output = levels.map((level) => ({
      skillId: item.skillId,
      keywords: item.keywords.toLowerCase(),
      level,
    }));
    const mergedSkills = output.reduce(
      (acc: any, { skillId, keywords, level }) => {
        const existing: any = acc.find(
          (item: any) =>
            item.skillId === skillId &&
            item.keywords.toLowerCase() === keywords.toLowerCase(),
        );

        if (existing) {
          if (!existing.level.includes(level)) {
            existing.level.push(level);
          }
        } else {
          acc.push({
            skillId,
            keywords: keywords.toLowerCase(),
            level: [level],
          });
        }

        return acc;
      },
      [],
    );
    onAddSuggestionClick(mergedSkills);
  };

  useImperativeHandle(ref, () => ({
    addSuggestion: handleAddSuggestion,
  }));

  return (
    <div className="searchSuggestionContainer">
      <div className="searchInputWrapper">
        <InputField
          type="text"
          value={searchTerm}
          onChange={onChange}
          placeholder={t("GENERAL.SEARCH_KEYWORD")}
          additionalProps={{ className: "suggestionSearchInput" }}
        />
        {searchTerm ? (
          <div className="cursorPointer" onClick={onKeywordSearchCrossClick}>
            <CircleCrossIcon />
          </div>
        ) : (
          <SearchList />
        )}
      </div>
      {searchTerm && !loadingSuggestions && suggestions?.length === 0 && (
        <ul className="suggestionsList">
          <li className="suggestionItem">{t("GENERAL.NO_RESULT_FOUND")}</li>
        </ul>
      )}
    </div>
  );
});

SearchSuggestion.displayName = "SearchSuggestion";
export default SearchSuggestion;
